<template>
  <router-view/>
</template>

<script>
import socket, { connectUserSocket } from "@/plugins/socket";

export default {
  name: 'App',
  created() {
    this.restoreSocketConnection();
  },
  mounted() {
    // เผื่อ socket หลุดค้างขณะเปิดหน้าไว้ (เช่น เครือข่ายหลุด) — ต่อกลับเมื่อกลับมาโฟกัสแท็บ
    document.addEventListener("visibilitychange", this.onVisible);
    window.addEventListener("focus", this.onVisible);
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.onVisible);
    window.removeEventListener("focus", this.onVisible);
  },
  methods: {
    onVisible() {
      if (document.visibilityState === "hidden") return;
      if (!socket.connected) this.restoreSocketConnection();
    },

    // เชื่อม socket ใหม่ทุกครั้งที่แอปโหลด (รวมถึงหลัง refresh)
    // ใช้ตัวตน + role ที่ persist ไว้ แทนการพึ่ง isAuthenticated (ซึ่งไม่ถูก restore หลัง reload)
    // หมายเหตุ: flow ปัจจุบันเก็บตัวตนของทั้ง buyer และ seller ไว้ใน state.user
    // โดยแยกด้วย state.user.role ("user" | "seller") ดังนั้นต้องต่อ socket ตาม role จริง
    restoreSocketConnection() {
      const userId = this.$store.state.user?._id;
      const role = (this.$store.getters.role || "user").toLowerCase();

      if (userId) {
        if (role === "seller" && localStorage.getItem("seller_token")) {
          connectUserSocket(userId, "seller");
          return;
        }
        if (role === "user" && localStorage.getItem("user_token")) {
          connectUserSocket(userId, "user");
          return;
        }
        // rider: จัดการใน DefaultRider layout, admin: ไม่ track presence
      }

      // เผื่อ flow ที่เก็บ seller identity แยกไว้ใน state.seller
      const sellerId = this.$store.state.seller?.sellerId;
      if (sellerId && localStorage.getItem("seller_token")) {
        connectUserSocket(sellerId, "seller");
      }
    },
  },
};
</script>
